// extracted by mini-css-extract-plugin
module.exports = {"tabWrap":"payroll-info_tabWrap__3h10f","topPanel":"payroll-info_topPanel__3fuwf","signFieldTable":"payroll-info_signFieldTable__OuVfG","boardInfo":"payroll-info_boardInfo__2SDP6"};